var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-table-cell-text',{staticClass:"date"},[_c('span',[_vm._v(_vm._s(_vm._f("formatDate")(_vm.item.date,_vm.$hourFormat)))]),_c('span',[_vm._v(" on ")]),_c('span',[_vm._v(_vm._s(_vm._f("formatDate")(_vm.item.date,'dddd')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }